<h2 class="dialog-draggable-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  Add Assignment to Duty<mat-icon class="drag-handle">drag_indicator</mat-icon>
</h2>
<ng-container *ngIf="errors$ | async as errors">
  <div class="command-error-message">
    Errors found:
    <ul>
      <li *ngFor="let error of errors">
        {{ error.message }}
      </li>
    </ul>
  </div>
</ng-container>
<fl-pilot-employment-record-assignment-to-duty-form
  [employmentRecordId]="data.employmentRecordId"
></fl-pilot-employment-record-assignment-to-duty-form>
<div fxLayout fxLayoutGap="10px">
  <button
    mat-raised-button
    (click)="add(); clicked = true"
    [disabled]="pilotEmploymentRecordAssignmentToDutyFormCmp?.form.invalid || clicked"
  >
    Add
  </button>
  <a mat-button [mat-dialog-close]="true">Cancel</a>
</div>
